import { saveToSStore } from '../persistence/storage';
import { DATA_STORAGE_KEY as STORAGE_KEY } from './context';

export const initialState = {
  rehydrated: false,
  authenticated: false,
  sessionToken: null,
  username: '',
  clientName: '',
  clientId: null,
  userId: null,
  scopes: null,
  isStaff: false,
};

export const authReducer = (state, { type, payload }) => {
  switch (type) {
    case 'init': {
      const nextState = { ...payload };
      saveToSStore(nextState, STORAGE_KEY);
      return nextState;
    }
    case 'rehydrated': {
      return { ...state, rehydrated: true };
    }
    case 'setSessionToken': {
      const nextState = { ...state, sessionToken: payload.sessionToken };

      return nextState;
    }
    case 'loginSucceeded': {
      const {
        username,
        clientName,
        scopes,
        clientId,
        userId,
        sessionToken,
        isStaff,
      } = payload;
      const nextState = {
        ...state,
        username,
        clientName,
        scopes,
        clientId,
        userId,
        sessionToken,
        isStaff,
        authenticated: true,
      };

      saveToSStore(nextState, STORAGE_KEY);
      return nextState;
    }
    case 'logout': {
      const nextState = { ...initialState, rehydrated: true };
      saveToSStore(nextState, STORAGE_KEY);
      return nextState;
    }
    default:
      throw new Error(`Unhandled action type: ${type}`);
  }
};
